import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import { CountryCodeForState } from '@app/finxone-web-frontend/app/lib/services/state-service/state.service';
import { State } from '@finxone-platform/shared/sys-config-types';

@Component({
  selector: 'finxone-web-frontend-state-dropdown',
  templateUrl: './state-dropdown.component.html',
  standalone: false,
})
export class StateDropdownComponent {
  private _countryCode: CountryCodeForState;
  @Input() set countryCode(value: CountryCodeForState) {
    if (!value || value === this._countryCode) return;
    this._countryCode = value;
    this.loadStates();
  }

  get countryCode(): CountryCodeForState {
    return this._countryCode;
  }
  @Input() label = 'State';
  @Input() selectedStateOption: State | string | undefined;
  @Input() parentFormControlName: string;
  @Input() parentFormGroup: FormGroup;
  public states: State[];

  get resolvedSelectedState(): State | undefined {
    if (!this.selectedStateOption) return undefined;
    if (typeof this.selectedStateOption === 'string') {
      return this.states?.find((s) => s.state_code === this.selectedStateOption);
    }
    return this.selectedStateOption;
  }

  constructor(private configService: ConfigService) {}

  public onStateSelectionChange(selectedStateCode: string): void {
    const parentControl = this.parentFormGroup?.get(this.parentFormControlName);
    if (!parentControl) return;

    parentControl.setValue(selectedStateCode);
    parentControl.markAsDirty();
    parentControl.markAsTouched();
  }

  private loadStates(): void {
    if (!this.countryCode) return;

    this.configService.getStates(this.countryCode).subscribe((res: State[]) => {
      this.states = res || [];
    });
  }
}
